import type { ItineraryBlock } from '@/types/itinerary';

export function sortItineraryBlockByDate(itineraryBlocks: ItineraryBlock[]) {
  return itineraryBlocks?.sort((a, b) => {
    const startDateComparison = a.startDate.localeCompare(b.startDate);
    if (startDateComparison !== 0) {
      return startDateComparison;
    }
    return a.endDate.localeCompare(b.endDate);
  });
}
